"use strict";

exports.__esModule = true;
exports.default = mergeQueries;

function mergeQueries(query1, query2) {
  var _query, _query2;

  (_query = query1) != null ? _query : query1 = "";
  (_query2 = query2) != null ? _query2 : query2 = "";

  if (query1 === "" && "" === query2) {
    return "";
  } else if ("" !== query1 && query2 === "") {
    return query1;
  } else if ("" === query1 && query2 !== "") {
    return query2;
  } else {
    return `${query1}&${query2}`;
  }
}